import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import VerifyPage from './pages/VerifyPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ListsPage from './pages/ListsPage';
import ListDetailPage from './pages/ListDetailPage';
import OptimizePage from './pages/OptimizePage';
import AdminPage from './pages/AdminPage';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ textAlign: 'center', marginTop: 80 }}>Φόρτωση...</div>;
  return user ? <>{children}</> : <Navigate to="/login" />;
};

const AppRoutes = () => (
  <>
    <Navbar />
    <Routes>
      <Route path="/" element={<Navigate to="/products" />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/verify" element={<VerifyPage />} />
      <Route path="/products" element={<ProductsPage />} />
      <Route path="/products/:id" element={<ProductDetailPage />} />
      <Route path="/lists" element={<PrivateRoute><ListsPage /></PrivateRoute>} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/lists/:id" element={<PrivateRoute><ListDetailPage /></PrivateRoute>} />
      <Route path="/lists/:id/optimize" element={<PrivateRoute><OptimizePage /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/products" />} />
    </Routes>
  </>
);

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <div style={{ minHeight: '100vh', background: '#F0F4F8', fontFamily: 'Arial, sans-serif' }}>
        <AppRoutes />
      </div>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
